import React, { Component } from "react";
import { NavLink, withRouter } from "react-router-dom";

import IntlMessages from "util/IntlMessages";
import CustomScrollbars from "util/CustomScrollbars";
import { Button } from "@material-ui/core";

class SidenavContent extends Component {
  componentDidMount() {
    const { history } = this.props;
    const that = this;
    const pathname = `${history.location.pathname}`; // get current path

    const menuLi = document.getElementsByClassName("menu");
    for (let i = 0; i < menuLi.length; i++) {
      menuLi[i].onclick = function (event) {
        const parentLiEle = that.closest(this, "li");
        if (menuLi[i].classList.contains("menu") && parentLiEle !== null) {
          event.stopPropagation();

          if (menuLi[i].classList.contains("open")) {
            menuLi[i].classList.remove("open", "active");
          } else {
            menuLi[i].classList.add("open", "active");
          }
        } else {
          for (let j = 0; j < menuLi.length; j++) {
            const parentLi = that.closest(this, "li");
            if (
              menuLi[j] !== this &&
              (parentLi === null || !parentLi.classList.contains("open"))
            ) {
              menuLi[j].classList.remove("open");
            } else {
              if (menuLi[j].classList.contains("open")) {
                menuLi[j].classList.remove("open");
              } else {
                menuLi[j].classList.add("open");
              }
            }
          }
        }
      };
    }

    const activeLi = document.querySelector('a[href="' + pathname + '"]'); // select current a element
    try {
      const activeNav = this.closest(activeLi, "ul"); // select closest ul
      if (activeNav.classList.contains("sub-menu")) {
        this.closest(activeNav, "li").classList.add("open");
      } else {
        this.closest(activeLi, "li").classList.add("open");
      }
    } catch (error) {}
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { history } = nextProps;
    const pathname = `${history.location.pathname}`; // get current path

    const activeLi = document.querySelector('a[href="' + pathname + '"]'); // select current a element
    try {
      const activeNav = this.closest(activeLi, "ul"); // select closest ul
      if (activeNav.classList.contains("sub-menu")) {
        this.closest(activeNav, "li").classList.add("open");
      } else {
        this.closest(activeLi, "li").classList.add("open");
      }
    } catch (error) {}
  }

  closest(el, selector) {
    try {
      let matchesFn;
      // find vendor prefix
      [
        "matches",
        "webkitMatchesSelector",
        "mozMatchesSelector",
        "msMatchesSelector",
        "oMatchesSelector",
      ].some(function (fn) {
        if (typeof document.body[fn] === "function") {
          matchesFn = fn;
          return true;
        }
        return false;
      });

      let parent;

      // traverse parents
      while (el) {
        parent = el.parentElement;
        if (parent && parent[matchesFn](selector)) {
          return parent;
        }
        el = parent;
      }
    } catch (e) {}

    return null;
  }

  render() {
    return (
      <CustomScrollbars className=" scrollbar">
        <ul className="nav-menu">
          <li className="nav-header">
            <IntlMessages id="sidebar.main" />
          </li>
          <li className="menu no-arrow">
            <NavLink to="/odoc/dashboard">
              <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
              <span className="nav-text">
                <IntlMessages id="sidebar.dashboard" />{" "}
              </span>
            </NavLink>
          </li>
          <li className="menu collapse-box">
            <Button>
              <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
              <span className="nav-text">
                <IntlMessages id="sidebar.users" />
              </span>
            </Button>
            <ul className="sub-menu">
              <li>
                <NavLink className="prepend-icon" to="/odoc/users">
                  <span className="nav-text">
                    <IntlMessages id="sidebar.user.list" />
                  </span>
                </NavLink>
              </li>
              <li>
                <NavLink className="prepend-icon" to="/odoc/user/new">
                  <span className="nav-text">
                    <IntlMessages id="sidebar.user.new" />
                  </span>
                </NavLink>
              </li>
            </ul>
          </li>
          {/* <li className="menu collapse-box">
            <Button>
              <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
              <span className="nav-text">
                <IntlMessages id="sidebar.doctors" />
              </span>
            </Button>
            <ul className="sub-menu">
              <li>
                <NavLink className="prepend-icon" to="/odoc/doctors">
                  <span className="nav-text">
                    <IntlMessages id="sidebar.doctor.list" />
                  </span>
                </NavLink>
              </li>
              <li>
                <NavLink className="prepend-icon" to="/odoc/doctor/new">
                  <span className="nav-text">
                    <IntlMessages id="sidebar.doctor.new" />
                  </span>
                </NavLink>
              </li>
              <li>
                <NavLink className="prepend-icon" to="/odoc/doctor/leaves">
                  <span className="nav-text">
                    <IntlMessages id="sidebar.doctor.leave" />
                  </span>
                </NavLink>
              </li>
              <li>
                <NavLink className="prepend-icon" to="/odoc/doctor/onboard_url_generate">
                  <span className="nav-text">
                    <IntlMessages id="sidebar.doctor.onboard_url_generate" />
                  </span>
                </NavLink>
              </li>
              
            </ul>
          </li> */}
          <li className="menu collapse-box">
            <Button>
              <i className="zmdi zmdi-folder-person zmdi-hc-fw" />
              <span className="nav-text">
                <IntlMessages id="sidebar.doctors_details" />
              </span>
            </Button>
            <ul className="sub-menu" >
              <li className="nav-header">
                <span className="nav-text">
                    <IntlMessages id="sidebar.doctors_details.doctors" />
                  </span>
              </li>
              <li>
                <NavLink className="prepend-icon" to="/odoc/doctors">
                  <span className="nav-text">
                    <IntlMessages id="sidebar.doctor.list" />
                  </span>
                </NavLink>
              </li>
              <li>
                <NavLink className="prepend-icon" to="/odoc/doctor/new">
                  <span className="nav-text">
                    <IntlMessages id="sidebar.doctor.new" />
                  </span>
                </NavLink>
              </li>
              <li>
                <NavLink className="prepend-icon" to="/odoc/doctor/leaves">
                  <span className="nav-text">
                    <IntlMessages id="sidebar.doctor.leave" />
                  </span>
                </NavLink>
              </li>
              <li>
                <NavLink className="prepend-icon" to="/odoc/doctor/onboard_url_generate">
                  <span className="nav-text">
                    <IntlMessages id="sidebar.doctor.onboard_url_generate" />
                  </span>
                </NavLink>
              </li>
            </ul>
            <ul className="sub-menu" >
              <li className="nav-header">
                <span className="nav-text">
                    <IntlMessages id="sidebar.doctors_details.payments" />
                  </span>
              </li>
              <li>
                <NavLink className="prepend-icon" to="/odoc/payments">
                  <span className="nav-text">
                    <IntlMessages id="sidebar.payments.list" />
                  </span>
                </NavLink>
              </li>
              <li>
                <NavLink className="prepend-icon" to="/odoc/payment/new">
                  <span className="nav-text">
                    <IntlMessages id="sidebar.payment.new" />
                  </span>
                </NavLink>
              </li>              
            </ul>
            <ul className="sub-menu" >
              <li className="nav-header">
                <span className="nav-text">
                    <IntlMessages id="sidebar.doctors_details.reports" />
                  </span>
              </li>
              <li>
                <NavLink
                  className="prepend-icon"
                  to="/odoc/master/doctor_report_configs"
                >
                  <span className="nav-text">
                    <IntlMessages id="sidebar.masterdata.report_configurations" />
                  </span>
                </NavLink>
              </li>              
            </ul>
          </li>
          
          <li className="menu collapse-box">
            <Button>
              <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
              <span className="nav-text">
                <IntlMessages id="sidebar.subscriptions" />
              </span>
            </Button>
            <ul className="sub-menu">
              <li>
                <NavLink className="prepend-icon" to="/odoc/subscriptions">
                  <span className="nav-text">
                    <IntlMessages id="sidebar.subscription.list" />
                  </span>
                </NavLink>
              </li>
              <li>
                <NavLink className="prepend-icon" to="/odoc/subscription/new">
                  <span className="nav-text">
                    <IntlMessages id="sidebar.subscription.new" />
                  </span>
                </NavLink>
              </li>
            </ul>
          </li>
          {/* <li className="menu collapse-box">
            <Button>
              <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
              <span className="nav-text">
                <IntlMessages id="sidebar.payments" />
              </span>
            </Button>
            <ul className="sub-menu">
              <li>
                <NavLink className="prepend-icon" to="/odoc/payments">
                  <span className="nav-text">
                    <IntlMessages id="sidebar.payments.list" />
                  </span>
                </NavLink>
              </li>
              <li>
                <NavLink className="prepend-icon" to="/odoc/payment/new">
                  <span className="nav-text">
                    <IntlMessages id="sidebar.payment.new" />
                  </span>
                </NavLink>
              </li>
            </ul>
          </li> */}
          <li className="menu collapse-box">
            <Button>
              <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
              <span className="nav-text">
                <IntlMessages id="sidebar.businesses" />
              </span>
            </Button>
            <ul className="sub-menu">
              <li>
                <NavLink className="prepend-icon" to="/odoc/businesses">
                  <span className="nav-text">
                    <IntlMessages id="sidebar.business.list" />
                  </span>
                </NavLink>
              </li>
              <li>
                <NavLink className="prepend-icon" to="/odoc/business/new">
                  <span className="nav-text">
                    <IntlMessages id="sidebar.business.new" />
                  </span>
                </NavLink>
              </li>
            </ul>
          </li>
          <li className="menu collapse-box">
            <Button>
              <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
              <span className="nav-text">
                <IntlMessages id="sidebar.promotions" />
              </span>
            </Button>
            <ul className="sub-menu">
              <li>
                <NavLink className="prepend-icon" to="/odoc/promotions">
                  <span className="nav-text">
                    <IntlMessages id="sidebar.promotion.list" />
                  </span>
                </NavLink>
              </li>
              <li>
                <NavLink className="prepend-icon" to="/odoc/promotion/new">
                  <span className="nav-text">
                    <IntlMessages id="sidebar.promotion.new" />
                  </span>
                </NavLink>
              </li>
            </ul>
          </li>
          <li className="menu collapse-box">
            <Button>
              <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
              <span className="nav-text">
                <IntlMessages id="sidebar.packages" />
              </span>
            </Button>
            <ul className="sub-menu">
              <li>
                <NavLink className="prepend-icon" to="/odoc/packages">
                  <span className="nav-text">
                    <IntlMessages id="sidebar.package.list" />
                  </span>
                </NavLink>
              </li>
              <li>
                <NavLink className="prepend-icon" to="/odoc/package/new">
                  <span className="nav-text">
                    <IntlMessages id="sidebar.package.new" />
                  </span>
                </NavLink>
              </li>
            </ul>
          </li>
          <li className="menu collapse-box">
            <Button>
              <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
              <span className="nav-text">
                <IntlMessages id="sidebar.features" />
              </span>
            </Button>
            <ul className="sub-menu">
              <li>
                <NavLink className="prepend-icon" to="/odoc/features">
                  <span className="nav-text">
                    <IntlMessages id="sidebar.feature.list" />
                  </span>
                </NavLink>
              </li>
              <li>
                <NavLink className="prepend-icon" to="/odoc/feature/new">
                  <span className="nav-text">
                    <IntlMessages id="sidebar.feature.new" />
                  </span>
                </NavLink>
              </li>
            </ul>
          </li>
          <li className="menu collapse-box">
            <Button>
              <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
              <span className="nav-text">
                <IntlMessages id="sidebar.patients" />
              </span>
            </Button>
            <ul className="sub-menu">
              <li>
                <NavLink className="prepend-icon" to="/odoc/patients">
                  <span className="nav-text">
                    <IntlMessages id="sidebar.patient.list" />
                  </span>
                </NavLink>
              </li>
            </ul>
          </li>
          <li className="menu collapse-box">
            <Button>
              <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
              <span className="nav-text">
                <IntlMessages id="sidebar.content" />
              </span>
            </Button>
            <ul className="sub-menu">
              <li>
                <NavLink className="prepend-icon" to="/odoc/contents">
                  <span className="nav-text">
                    <IntlMessages id="sidebar.content.list" />
                  </span>
                </NavLink>
              </li>
              <li>
                <NavLink className="prepend-icon" to="/odoc/content/new">
                  <span className="nav-text">
                    <IntlMessages id="sidebar.content.new" />
                  </span>
                </NavLink>
              </li>
            </ul>
          </li>
          <li className="menu collapse-box">
            <Button>
              <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
              <span className="nav-text">
                <IntlMessages id="sidebar.health_partner" />
              </span>
            </Button>
            <ul className="sub-menu">
              <li>
                <NavLink className="prepend-icon" to="/odoc/health_partners">
                  <span className="nav-text">
                    <IntlMessages id="sidebar.health_partner.list" />
                  </span>
                </NavLink>
              </li>
              <li>
                <NavLink className="prepend-icon" to="/odoc/health_partner/new">
                  <span className="nav-text">
                    <IntlMessages id="sidebar.health_partner.new" />
                  </span>
                </NavLink>
              </li>
            </ul>
          </li>

          {/* Doctor shifting */}
          <li className="menu collapse-box">
            <Button>
              <i className="zmdi zmdi-assignment zmdi-hc-fw" />
              <span className="nav-text">
                <IntlMessages id="sidebar.doctor_shift" />
              </span>
            </Button>
            <ul className="sub-menu">
              <li>
                <NavLink
                  className="prepend-icon"
                  to="/odoc/doctor_shifting/list"
                >
                  <span className="nav-text">
                    <IntlMessages id="sidebar.doctor_shift.list" />
                  </span>
                </NavLink>
              </li>
              
              <li>
                <NavLink
                  className="prepend-icon"
                  to="/odoc/doctor_shifting/activeList"
                >
                  <span className="nav-text">
                    <IntlMessages id="sidebar.doctor_activeshift.list" />
                  </span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  className="prepend-icon"
                  to="/odoc/doctor_shifting/create"
                >
                  <span className="nav-text">
                    <IntlMessages id="sidebar.doctor_shift.create" />
                  </span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  className="prepend-icon"
                  to="/odoc/doctor_shifting/shiftCategory"
                >
                  <span className="nav-text">
                    <IntlMessages id="sidebar.doctor_shift.shift_category" />
                  </span>
                </NavLink>
              </li>
            </ul>
          </li>

             {/* Schedular */}
          <li className="menu collapse-box">
            <Button>
              <i className="zmdi zmdi-assignment zmdi-hc-fw" />
              <span className="nav-text">
                <IntlMessages id="sidebar.schedular" />
              </span>
            </Button>
            <ul className="sub-menu">
              <li>
                <NavLink
                  className="prepend-icon"
                  to="/odoc/schedular/configAdd"
                >
                  <span className="nav-text">
                    <IntlMessages id="sidebar.schedular.configAdd" />
                  </span>
                </NavLink>
              </li>
              
              {/* <li>
                <NavLink
                  className="prepend-icon"
                  to="/odoc/schedular/configExpire"
                >
                  <span className="nav-text">
                    <IntlMessages id="sidebar.schedular.configExpire" />
                  </span>
                </NavLink>
              </li> */}
              <li>
                <NavLink
                  className="prepend-icon"
                  to="/odoc/schedular/sessionView"
                >
                  <span className="nav-text">
                    <IntlMessages id="sidebar.schedular.sessionView" />
                  </span>
                </NavLink>
              </li>
              {/* <li>
                <NavLink
                  className="prepend-icon"
                  to="/odoc/doctor_shifting/shiftCategory"
                >
                  <span className="nav-text">
                    <IntlMessages id="sidebar.doctor_shift.shift_category" />
                  </span>
                </NavLink>
              </li> */}
            </ul>
          </li>

          <li className="menu collapse-box">
            <Button>
              <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
              <span className="nav-text">
                <IntlMessages id="sidebar.consultation" />
              </span>
            </Button>
            <ul className="sub-menu">
              <li>
                <NavLink className="prepend-icon" to="/odoc/consultation/new_consultaion">
                  <span className="nav-text">
                    <IntlMessages id="sidebar.consultation.new_consultaion" />
                  </span>
                </NavLink>
              </li>
              <li>
                <NavLink className="prepend-icon" to="/odoc/consultation/actual_consultaions">
                  <span className="nav-text">
                    <IntlMessages id="sidebar.consultation.actual_consultaions" />
                  </span>
                </NavLink>
              </li>
              <li>
                <NavLink className="prepend-icon" to="/odoc/consultation/tempory_consultaions">
                  <span className="nav-text">
                    <IntlMessages id="sidebar.consultation.tempory_consultaions" />
                  </span>
                </NavLink>
              </li>
              <li>
                <NavLink className="prepend-icon" to="/odoc/consultations">
                  <span className="nav-text">
                    <IntlMessages id="sidebar.consultation.list" />
                  </span>
                </NavLink>
              </li>
         
            </ul>
          </li>

          <li className="menu collapse-box">
            <Button>
              <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
              <span className="nav-text">
                <IntlMessages id="sidebar.masterdata" />
              </span>
            </Button>
            <ul className="sub-menu">
              <li>
                <NavLink className="prepend-icon" to="/odoc/master/countries">
                  <span className="nav-text">
                    <IntlMessages id="sidebar.masterdata.countires" />
                  </span>
                </NavLink>
              </li>
              <li>
                <NavLink className="prepend-icon" to="/odoc/master/langs">
                  <span className="nav-text">
                    <IntlMessages id="sidebar.masterdata.langs" />
                  </span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  className="prepend-icon"
                  to="/odoc/master/country_langs"
                >
                  <span className="nav-text">
                    <IntlMessages id="sidebar.masterdata.country_langs" />
                  </span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  className="prepend-icon"
                  to="/odoc/master/specialities"
                >
                  <span className="nav-text">
                    <IntlMessages id="sidebar.masterdata.specialities" />
                  </span>
                </NavLink>
              </li>
              {/* <li>
                <NavLink
                  className="prepend-icon"
                  to="/odoc/master/doctor_report_configs"
                >
                  <span className="nav-text">
                    <IntlMessages id="sidebar.masterdata.report_configurations" />
                  </span>
                </NavLink>
              </li> */}
            </ul>
          </li>
          <li className="menu collapse-box">
            <Button>
              <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
              <span className="nav-text">Temps</span>
            </Button>
            <ul className="sub-menu">
              <li>
                <NavLink className="prepend-icon" to="/odoc/temps">
                  <span className="nav-text">Temp fixes</span>
                </NavLink>
              </li>
            </ul>
          </li>

          <li className="menu collapse-box">
            <Button>
              <i className="zmdi zmdi-storage zmdi-hc-fw" />
              <span className="nav-text">
                <IntlMessages id="sidebar.tanent" />
              </span>
            </Button>
            <ul className="sub-menu">
              <li>
                <NavLink className="prepend-icon" to="/odoc/tanent">
                  <span className="nav-text">
                    <IntlMessages id="sidebar.tanent.list" />
                  </span>
                </NavLink>
              </li>
            </ul>
          </li>
          
        </ul>
      </CustomScrollbars>
    );
  }
}

export default withRouter(SidenavContent);